<template lang="pug">
.external-rights-container(v-if="externalData && externalData.length > 0")
  .external-rights-title 吃喝玩乐优惠
  .external-rights-tabs-wrapper
    .external-rights-category-tabs
      .external-rights-tab-item(
        v-for="tab in tabList"
        :key="tab.id"
        :class="{ active: tab.id === activeTab }"
        @click="handleTabClick(tab.id)") {{ tab.name }}
    .external-rights-tabs-gradient
  .external-rights-content
    .external-rights-content-item(
      v-for="item in paginationData.currentList"
      :key="item.id"
    )
      img.item-right-img(:src="item.rightImg")
      .item-right-title {{ item.rightTitle }}
      .item-right-amount {{ item.rightAmount }}
      .item-right-btn(@click="handleRights(item.bonusRedirectUrl)") {{ item.rightBtnText }}
  .external-rights-more.flex-mid(v-if="paginationData.showMore" @click="showMoreRights")
    span 更多权益
    .common-arrow-down
</template>

<script>
import { Icon } from '@hb/platformui-h5';
import { safeGet, debounce } from '@/utils';
import { Navigator } from '@hb/h5-navigator';

const BTN_STATUS = {
  unReceive: '0元领',
  toUse: '去领取',
};

export default {
  name: 'ExternalRights',
  components: {
    Icon,
  },
  props: {
    externalInfo: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      tabList: [],
      rightList: [],
      activeTab: '',
      externalData: [],
      // 分页
      currentPage: 1,
      pageSize: 12,
      showMoreButton: true,
    };
  },
  computed: {
    paginationData() {
      let filteredList = [];
      // if (this.activeTab === 'all') {
      // filteredList = [...this.rightList];
      // } else {
      filteredList = this.rightList.filter((item) => item.groupCode === this.activeTab);
      // }
      const totalToShow = 9 + (this.currentPage - 1) * this.pageSize;

      return {
        currentList: filteredList.slice(0, totalToShow),
        showMore: filteredList.length > totalToShow,
      };
    },
  },
  mounted() {
    this.externalData = safeGet(this.externalInfo, 'couponInfoGroups', []);
    this.initData();
  },
  methods: {
    initData() {
      this.tabList = [
        // { id: 'all', name: '全部' },
        ...this.externalData.map((group) => {
          const { groupCode = '', groupName = '' } = group || {};
          return {
            id: groupCode,
            name: groupName,
          };
        }),
      ];

      //  聚合 rightList
      this.rightList = this.externalData.reduce((acc, group) => {
        const { coupons = [], groupCode = '' } = group || {};

        if (!Array.isArray(coupons)) {
          return acc;
        }

        const groupRights = coupons.map((coupon, index) => {
          const {
            skuName = '',
            propAmount = 0,
            skuIcon = '',
            bonusRedirectUrl = '',
          } = coupon.bonusExtra || {};

          return {
            id: `${groupCode}-${index}`,
            rightTitle: skuName,
            rightAmount: `价值${propAmount}元`,
            rightImg: skuIcon,
            rightBtnText: BTN_STATUS.toUse,
            groupCode,
            bonusRedirectUrl,
            bonusStatus: coupon.bonusStatus || '',
          };
        });
        return acc.concat(groupRights);
      }, []);
      const tabInfo = this.tabList[0] || {};
      this.activeTab = tabInfo.id || '';
    },
    handleRights: debounce((url) => {
      Navigator.go(url);
    }, 300),
    showMoreRights() {
      this.currentPage += 1;
    },
    handleTabClick(id) {
      this.activeTab = id;
      this.currentPage = 1;
    },
  },
};
</script>

<style lang="less" scoped>
.external-rights-container {
  background: #fff;
  margin: 0.1rem 0.12rem;
  padding: 0.14rem 0 0.19rem 0;
  border-radius: 0.16rem;

  .external-rights-title {
    font-weight: 600;
    font-size: 0.16rem;
    padding-left: 0.15rem;
  }

  .external-rights-tabs-wrapper {
    position: relative;
    margin-top: 0.16rem;

    .external-rights-category-tabs {
      display: flex;
      padding-left: 0.11rem;
      gap: 0.06rem;
      overflow-x: auto;
      overflow-y: hidden;
      white-space: nowrap;

      &::-webkit-scrollbar {
        display: none;
      }

      .external-rights-tab-item {
        font-size: 0.14rem;
        font-weight: 400;
        padding: 0 0.1rem;
        height: 0.25rem;
        line-height: 0.25rem;
        flex-shrink: 0;
        white-space: nowrap;
        text-align: center;

        &.active {
          background: #ffe29c;
          border-radius: 0.12rem;
        }
      }
    }

    .external-rights-tabs-gradient {
      position: absolute;
      top: 0;
      right: 0;
      width: 0.4rem;
      height: 100%;
      background: linear-gradient(270deg, #fff 0%, #fff 30%, rgba(255, 255, 255, 0) 100%);
      pointer-events: none;
      z-index: 1;
    }
  }

  .external-rights-content {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 0.08rem;
    padding: 0.16rem 0.1rem 0;

    .external-rights-content-item {
      padding-bottom: 0.055rem;
      height: 1.29rem;
      background-image: url('https://m.hellobike.com/ac2e25a544.png');
      background-size: 100% 100%;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: space-around;

      .item-right-img {
        width: 0.6rem;
        height: 0.6rem;
        padding-top: 0.01rem;
      }

      .item-right-title {
        font-size: 0.12rem;
        font-weight: 500;
        height: 0.22rem;
        line-height: 0.22rem;
        max-width: 0.91rem;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }

      .item-right-amount {
        font-size: 0.11rem;
        font-weight: normal;
        color: #a5a5a5;
        height: 0.15rem;
        line-height: 0.15rem;
        max-width: 0.91rem;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }

      .item-right-btn {
        width: 0.6rem;
        height: 0.24rem;
        margin-top: 0.06rem;
        border-radius: 0.06rem;
        background: linear-gradient(90deg, #ff5f5d 0%, #ff4e1c 100%);
        text-align: center;
        line-height: 0.24rem;
        font-size: 0.12rem;
        font-weight: 500;
        color: #fff;
      }
    }
  }

  .external-rights-more {
    width: 1.06rem;
    height: 0.27rem;
    margin: 0 auto;
    margin-top: 0.16rem;
    text-align: center;
    line-height: 0.27rem;
    border-radius: 0.32rem;
    background: #f0f3f5;
    font-size: 0.12rem;
    font-weight: 400;
    color: #5a6066;

    .common-arrow-down {
      border-color: #5a6066;
    }
  }
}

.free-rights-version {
  .external-rights-container {
    margin: 0.1rem 0.08rem;
  }
}
</style>
